import React, { createContext, useReducer } from 'react';
import { PaginationType } from '@cloudez/cloudez-design-system';
import { Email } from 'types/email';
import reducer from './reducer';
import { setLoading, getEmails, updateEmail } from './actions';

export interface EmailListingState extends PaginationType {
  emails: Email[];
  loading: boolean;
  errors: any;
  setLoading(value: boolean): void;
  getEmails(
    page: string | number,
    search: string,
    filter: any,
    clouds: any,
    order: any,
    ctrl: AbortController,
  ): Promise<void>;
  updateEmail(field: string, value: any, id?: number | string): Promise<void>;
}

// initial state
const initialState = {
  emails: null,
  count: null,
  previous: null,
  current: null,
  next: null,
  loading: true,
  errors: null,
};

// context
export const EmailListingContext = createContext<EmailListingState>(
  initialState as EmailListingState,
);

// provider
export const EmailListingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    reducer,
    initialState as EmailListingState,
  );

  return (
    <EmailListingContext.Provider
      value={{
        // state
        emails: state.emails,
        count: state.count,
        previous: state.previous,
        current: state.current,
        next: state.next,
        loading: state.loading,
        errors: state.errors,

        // actions
        setLoading: value => setLoading(dispatch, value),
        getEmails: async (page, search, filter, clouds, order, ctrl) =>
          await getEmails(dispatch, page, search, filter, clouds, order, ctrl),
        updateEmail: async (field, value, id) =>
          await updateEmail(dispatch, field, value, id),
      }}
    >
      {children}
    </EmailListingContext.Provider>
  );
};
